import { jsx } from "react/jsx-runtime";
import React from "react";
class AnnotationPositioner extends React.PureComponent {
  render() {
    return /* @__PURE__ */ jsx(
      "svg",
      {
        "data-y-offset": this.props.yOffset,
        transform: this.props.transform || null,
        height: `${Math.max(0, this.props.height)}px`,
        className: (this.props.className || "") + " veRowViewAnnotationPosition",
        width: Math.max(0, this.props.width + 5),
        style: {
          position: "absolute",
          top: this.props.top,
          left: this.props.left
        },
        children: this.props.children
      }
    );
  }
}
export default AnnotationPositioner;
